import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';

interface AdminPermissionsResponse {
  success: boolean;
  data: {
    permissions: string[];
    roles: string[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  permissions: string[] = [];
  roles: string[] = [];

  private isLoading = false;
  private isLoaded = false;

  constructor(private readonly api: ApiService) {}

  async getPermissions(): Promise<void> {
    if (this.isLoaded) {
      return;
    }

    if (this.isLoading) {
      return new Promise((resolve) => {
        const checkLoaded = () => {
          if (this.isLoaded) {
            resolve();
          } else {
            setTimeout(checkLoaded, 100);
          }
        };
        checkLoaded();
      });
    }

    this.isLoading = true;

    try {
      const response = await firstValueFrom(
        this.api.get<AdminPermissionsResponse>('/admin/get-permissions'),
      );

      this.permissions = response.data?.permissions ?? [];
      this.roles = response.data?.roles ?? [];
      this.isLoaded = true;
    } catch {
      this.permissions = [];
      this.roles = [];
    } finally {
      this.isLoading = false;
    }
  }

  removePermissions(): void {
    this.permissions = [];
    this.roles = [];
    this.isLoaded = false;
    this.isLoading = false;
  }

  hasPermission(permission: string | null | undefined): boolean {
    if (permission === null || permission === undefined || permission === '') {
      return true;
    }

    return this.permissions.includes(permission);
  }
}
